app.controller("StudentNewSubjectInfoModalController", [
    "$scope", "$q", "StSubject", "subject", "$uibModalInstance",
    function ($scope, $q, StSubject, subject, $uibModalInstance) {
        $scope.subject = subject;
        $scope.post = subject.post;

        if(!$scope.subject.consultation) {
            subject.subjectSessionGroups.forEach(function(group) {
                if (group.lastPost && group.lastPost.length) {
                    $scope.post = group.lastPost[0];
                }
            });
        }

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
